<mat-card id="add-category">
  <form
    #f="ngForm"
    [formGroup]="categoryForm"
    (ngSubmit)="saveCategory()"
    class="pb-3"
  >
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">
        <span *ngIf="mode === 'create'">
          {{ "title.add_category" | translate }}
        </span>
        <span *ngIf="mode === 'update'">{{
          "title.update_category" | translate
        }}</span>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <mat-accordion [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <!--Thong tin danh muc-->
          <mat-panel-title
            class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center"
          >
            <span>{{ "title.category_info" | translate }}</span>
          </mat-panel-title>
          <div class="row">
            <div class="col-4">
              <!-- Ten danh muc -->
              <mat-form-field class="w-100">
                <input
                  #focusInput
                  (focusout)="focusOut('name')"
                  matInput
                  type="text"
                  required
                  formControlName="name"
                  [placeholder]="'general_category.category_name' | translate"
                  maxlength="200"
                  autocomplete="off"
                  (keydown.enter)="$event.preventDefault()"
                />
                <button
                  mat-button
                  type="button"
                  *ngIf="categoryForm?.controls?.name?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('name')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="!categoryForm.controls.name.value">
                  {{ "general_category.error_required_name" | translate }}
                </mat-error>
                <mat-error *ngIf="categoryForm.controls.name.hasError('exist')">
                  {{ "general_category.exist_name_category" | translate }}
                </mat-error>
                <mat-error *ngIf="categoryForm.controls.name.value?.length > 200">
                  {{ "general_category.maxlength_name" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <!-- danh muc cha -->
              <mat-form-field class="w-100">
                <mat-select
                  formControlName="parent"
                  #matSelect
                  (selectionChange)="onChangeParent($event)"
                  [placeholder]="'general_category.category_parent' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchParentCtrl"
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [searching]="loadingSearch"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let parent of listParentsFilter | async"
                    [value]="parent?.parentId"
                    >{{ parent?.parentName }}</mat-option
                  >
                </mat-select>
                <button
                  mat-button
                  type="button"
                  *ngIf="categoryForm?.controls?.parent?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('parent')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <!-- Mo ta -->
              <mat-form-field class="w-100">
                <textarea
                  (focusout)="focusOut('description')"
                  matInput
                  type="text"
                  [placeholder]="
                    'general_category.category_description' | translate
                  "
                  maxlength="500"
                  autocomplete="off"
                  rows="2"
                  formControlName="description"
                ></textarea>
                <button
                  mat-button
                  type="button"
                  *ngIf="categoryForm?.controls?.description?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('description')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel  expanded="true" class="mt-3">
          <mat-panel-title
            class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center"
          >
            <span *ngIf="mode === 'create'">{{
              "title.category_table_value" | translate
              }}</span>
            <span *ngIf="mode === 'update'">{{
              "title.category_detail" | translate
              }}</span>
          </mat-panel-title>
          <div class="row" style="padding-left: 50px; padding-right: 20px;margin: 0">
            <!-- Loc theo ma -->
            <div class="filter">
              <mat-form-field class="w-100">
                <input
                  matInput
                  type="text"
                  [placeholder]="'general_category.code' | translate"
                  name="name"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="codeContains"
                  (input)="filterTable()"
                  (keydown.enter)="$event.preventDefault()"
                />
                <button
                  mat-button
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  *ngIf="categoryForm?.controls?.codeContains?.value"
                  (click)="clearData('codeContains')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!-- Loc theo gia tri -->
            <div class="filter">
              <mat-form-field class="w-100">
                <input
                  matInput
                  type="text"
                  [placeholder]="'general_category.value' | translate"
                  name="merge_field"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="valueContains"
                  (input)="filterTable()"
                  (keydown.enter)="$event.preventDefault()"
                />
                <button
                  mat-button
                  type="button"
                  *ngIf="categoryForm?.controls?.valueContains?.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('valueContains')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <!-- Bang gia tri danh muc -->
          <div class="row">
            <div class="col-12">
              <div
                style="
                  /* overflow: scroll; */
                  /* width: 100%; */
                  max-height: 300px;
                  /* position: relative; */
                "
              >
                <div id="tableContractId"></div>
              </div>
            </div>
          </div>
          <div class="no-data" *ngIf="noData">
            {{ "form.no_record" | translate }}
          </div>
          <!-- Them dong -->
          <div class="row" style="margin-top: 10px">
            <div class="col-4">
              <mat-icon
                class="mr-0"
                style="color: #09847b; font-size: x-large; cursor: pointer"
                matTooltip="{{ 'general_category.tooltip_add' | translate }}"
                (click)="createNewItem()"
              >add_circle_outline</mat-icon
              >
            </div>
            <div class="col-8 text-right">
              <span style="opacity: 0.6">{{
                "general_category.note" | translate
                }}</span>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="pr-0 fixed-bottom">
        <div class="bg-white text-center mat-elevation-z0 py-2 w-100">
          <button
            mat-stroked-button
            color="primary"
            class="mr-3"
            type="button"
            (click)="cancel()"
          >
            <mat-icon class="mr-0">cancel</mat-icon
            >{{ "button.cancel" | translate }}
          </button>
          <button mat-raised-button color="primary" type="submit" id="save">
            <mat-icon class="mr-0">save</mat-icon
            ><span *ngIf="mode === 'update'">{{
            "button.update" | translate
            }}</span>
            <span *ngIf="mode === 'create'">{{
              "button.add" | translate
              }}</span>
          </button>
        </div>
      </div>
    </mat-card-content>
  </form>
</mat-card>
